export const FIND_RESULT_REQUEST = 'FIND_RESULT_REQUEST';

export const findResultRequest = ( id ) => ({
    type: FIND_RESULT_REQUEST,
    payload: { id }
});
